<template>
    <div class="insights">
        <v-container fluid>
            <dynamic-insights></dynamic-insights>
        </v-container>
        <v-container fluid>
            <channels></channels>
        </v-container>
        <!-- <v-container fluid>
            <unknown-words></unknown-words>
        </v-container> -->
    </div>
</template>

<script>
    import common from "../utils/common";
    import channels from "../components/insights/channels";
    // import unknownWords from '../components/insights/unknown-words'
    import dynamicInsights from '../components/insights/dynamic-insights/graphe-loader'
    export default {
        name: "analytics",
        components: {
            channels,
            // unknownWords,
            dynamicInsights
        }
    }
</script>

<style scoped>

</style>
